import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://ink-it.ink';
const SITE_NAME = 'Ink it';
const OG_IMAGE = `${SITE_URL}/logo512.png`;

const pageKeys = {
    '/': 'home',
    '/solutions': 'solutions',
    '/contact': 'contact',
    '/faq': 'faq',
    '/terms': 'terms',
    '/privacy': 'privacy'
};

const setMeta = (attr, key, content) => {
    if (!content) return;
    let el = document.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
};

export function Seo() {
    const { t, i18n } = useTranslation();
    const { pathname } = useLocation();

    useEffect(() => {
        const key = pageKeys[pathname] || 'home';
        const title = t(`meta.${key}.title`, { defaultValue: SITE_NAME });
        const description = t(`meta.${key}.description`, { defaultValue: '' });
        const canonical = SITE_URL + (pathname !== '/' ? pathname : '/');
        const lang = i18n.language === 'en' ? 'en' : 'es';

        document.title = title;
        document.documentElement.lang = lang;

        setMeta('name', 'description', description);
        setMeta('property', 'og:title', title);
        setMeta('property', 'og:description', description);
        setMeta('property', 'og:url', canonical);
        setMeta('property', 'og:locale', lang === 'en' ? 'en_US' : 'es_MX');
        setMeta('property', 'og:image', OG_IMAGE);
        setMeta('property', 'og:site_name', SITE_NAME);
        setMeta('name', 'twitter:title', title);
        setMeta('name', 'twitter:description', description);
        setMeta('name', 'twitter:image', OG_IMAGE);

        const canonicalLink = document.querySelector('link[rel="canonical"]');
        if (canonicalLink) canonicalLink.setAttribute('href', canonical);
    }, [pathname, t, i18n.language]);

    return null;
}

export default Seo;